import { UntypedFormGroup } from '@angular/forms'

import { Clinician } from '../../model/clinician'
import { CustomQuestionSchema } from '../../schema'
import { SelectOption } from '../'
import { PatientIntakeFormData } from '../intake-form-data.class'
import { QuestionBase, QuestionOptions } from './base.question.class'

class File {}

interface PhotoQuestionOptions extends QuestionOptions<File> {
  options?: SelectOption<string>[]
  insurance?: boolean
}

export class FileQuestion extends QuestionBase<File> {
  controlType = 'input-file-upload'
  insurance = false

  saveValueToData(
    data: PatientIntakeFormData,
    form: UntypedFormGroup,
    clinician: Clinician,
  ) {
    if (this.isCustom) {
      const customData: CustomQuestionSchema = {
        id: this.id,
        value: form.value[this.id].value,
        note: form.value[this.id].note,
        isImage: true,
      }

      data.saveCustomQuestion(customData, clinician.id)
    } else {
      data[this.key] = form.value[this.key].value
    }
  }
}

export class PhotoQuestion extends FileQuestion {
  declare options: SelectOption<string>[]

  constructor(options: PhotoQuestionOptions = {}) {
    super(options)
    this.options = options.options || []
  }

  // TODO: just validate file upload type
}
